import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Phone } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Servizi from "@/pages/Servizi";
import PercheNoi from "@/pages/PercheNoi";
import Management from "@/pages/Management";
import Faq from "@/pages/Faq";
import Contatti from "@/pages/Contatti";
import { PrivacyPage, CookiePage } from "@/pages/Legal";

let lenisInstance = null;

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisInstance) {
      lenisInstance.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    lenisInstance = new Lenis({ autoRaf: true, duration: 1.15 });
    return () => {
      lenisInstance?.destroy();
      lenisInstance = null;
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/servizi" element={<Servizi />} />
            <Route path="/perche-noi" element={<PercheNoi />} />
            <Route path="/management" element={<Management />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cookie" element={<CookiePage />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <Link
          to="/contatti"
          data-testid="floating-call-button"
          className="group fixed bottom-6 right-6 z-40 inline-flex items-center gap-2 rounded-full bg-gold px-5 py-3 text-sm font-semibold text-navy shadow-xl shadow-navy/20 transition-all duration-300 hover:-translate-y-1 hover:bg-gold-light"
        >
          <Phone size={16} className="transition-transform duration-300 group-hover:rotate-12" />
          Chiamaci
        </Link>
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
